import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { User } from '../models/user';
import { FirebaseAuthService } from '../_services/firebase-auth.service';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, first, map } from 'rxjs/operators';



@Injectable()
export class SocialNetworkRegisterResolver implements Resolve<any> {

    constructor(private afAuth: AngularFireAuth, private firebaseAuthService: FirebaseAuthService) {
    }
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
       this.afAuth.authState.subscribe( user => {
           console.log('corre resolver', user);
           this.firebaseAuthService.publicUserToCreate = user;
       });

       return this.afAuth.authState.pipe(
        catchError((error) => {
            
            //         this.router.navigate(['/points']);
            return of(null);
           }) , first()
       );
    }

    // resolve( ): Observable<firebase.User> {
    //     console.log('oelo');
      

    //     return this.afAuth.authState.pipe(
    //        catchError( (error) => {
    //             console.log(error);
                
    //             return of(null);
    //         })
    //    );
    //    //  return this.afAuth.currentUser;
    // }

    // async resolve(route: ActivatedRouteSnapshot): Promise<User> {

    //     const firebaseUser = await this.afAuth.currentUser;
    //     console.log('resolver social N', firebaseUser );

    //     return this.firebaseAuthService.getPublicUserByEmail(firebaseUser.email).toPromise();
    // }
    
}